const hasRelationship = require("./hasRelationship");

module.exports = function getRowData(entity) {
	const cols_data = hasRelationship(entity.relationships.field_row_columns)
		? entity.relationships.field_row_columns.data
		: [];
	const default_col_w = Math.floor(12 / cols_data.length);
	const widths = [];
	let cols = cols_data.map((col_entity) => {
		const my_w = col_entity.attributes.field_column_width
			? col_entity.attributes.field_column_width
			: default_col_w;
		widths.push(my_w);
		const col_data = hasRelationship(col_entity.relationships.field_column_blocks)
			? col_entity.relationships.field_column_blocks.data
			: [];
		return col_data;
	});
	return { cols, widths };
};
